<template>
    <div>
        <v-card-title style="width: 100%; display: block;">
            <h1 style="display: inline;">Advanced Search</h1>
        </v-card-title>
    <v-tabs
        dark
        v-model="active">
      <v-tab to="/AdvancedSearch/Parliamentarians">
        Parliamentarians
      </v-tab>
      <v-tab to="/AdvancedSearch/Divisions">
        Divisions (Beta)
      </v-tab>           
    </v-tabs>
    <router-view></router-view>
    </div>
</template>
<script>
import AdvancedSearch from './AdvancedSearch.vue';
import AdvancedSearchDivisions from './AdvancedSearchDivisions.vue';
export default {
    components: {
        AdvancedSearch,
        AdvancedSearchDivisions
    },
    data () {
        return {
            active: null,
        }
    }
}
</script>